import * as yup from 'yup';


export const QuoteNotesValidationSchema = (total) => {
  return yup.object().shape({
    quoteName: yup.string(),
    expirationDate: yup
      .date()
      .required('Field is required'),
    quoteNotes: yup.string(),
    quoteDiscount: yup.object().shape({
      price_type: yup.string(),
      price: yup
        .number()
        .typeError('Allowed only numerical symbols')
        .positive('Value must be positive')
        .min(0, 'Price should be a positive number')
        .test(
          'price',
          'The unit price can\'t be lower than discount',
          function (value) {
            const { price_type } = this.parent;
            const formattedFixedPrice = total?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

            if (price_type === 'percent') {
              if (isNaN(value) || value < 0 || value > 100) {
                return this.createError({ message: 'Discount must be between 0 and 100' });
              }
            } else if (isNaN(value) || value < 0 || value > total) {
              return this.createError({
                message: `Discount must be between 0 and $${formattedFixedPrice}`,
              });
            }

            return true;
          }
        )
        .required('Field is required'),
    }),

  }, [['expirationDate', 'startDate']]);
};
